import { AvailableMetric } from '@spotify/confidence-editor-react';

import { MetricRow } from './types';

export const createMetricRow = (metric: AvailableMetric): MetricRow => ({
  metricId: metric.id,
  name: metric.name,
  type: metric.type,
  value: metric.value || '—',
  sampleSize: metric.sampleSize?.toLocaleString() || '—',
  lowerBound: metric.lowerBound || '—',
  upperBound: metric.upperBound || '—',
  outcome: metric.conclusion || 'No data available',
  status: metric.status,
  hasNoninferiorityMargin: metric.hasNoninferiorityMargin,
});
